import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const firmLogApi = createApi({
  reducerPath: "firmLog",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["FirmLog"],
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      getFirmLogReport: builder.mutation({
        query: (data) => apiFunction(data, `/api/firmLog/storageRoles/report`, "POST"),
      }),
      // Raporlar sekmesi → Tüketim (#343): PDF + Excel sayfaları
      getFirmDetailPerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/firmLog/storageRoles/performance-report`, "POST"),
      }),
      getFirmConsumentLogReport: builder.query({
        query: (data) =>
          apiFunction(data, `/api/firmLog/storageRoles/report/consument`, "POST"),
      }),
    };
  },
});

export const {
  useGetFirmConsumentLogReportQuery,
  useGetFirmLogReportMutation,
  useGetFirmDetailPerformanceReportMutation,
} = firmLogApi;
export { firmLogApi };
